<template>

    <b-modal id="clientpluginupdate" centered ref="clientpluginupdate" size="custom-lg" title="Important Update" :hide-header-close="true" :lazy="true" @show="getSelectedSites" modal-class="updatepopup" no-fade>
        <div class="prompt-text p-4 text-center">
            An important update to the
            <strong>IWP Client Plugin</strong> version {{update.clientUpdateVersion}} is available. We
            <strong>highly recommend</strong> that you update it on all your sites.
        </div>

        <b-row class="sitelist-container">
            <div class="card">
                <div class="card-header">
                    This action will affect in selected websites:
                </div>
                <div class="card-body update-site-list">
                    <div class="site-name" v-for="(siteID,index) in sites" :key="index">
                        <img class="favicon-img" :src="appInfo.APP_URL_V2+allSites[siteID].favicon" /> {{allSites[siteID].name}}
                    </div>
                </div>
            </div>
        </b-row>
        <b-row class="changelog-container">
            <div v-html="changeLogHTML"></div>
        </b-row>
        <div slot="modal-footer" class="w-100">
            <div class="text-right">
                <b-btn class="" variant="flat" @click="close">
                    Not now
                </b-btn>
                <b-btn variant="primary" @click="updateAll">
                    Update now
                </b-btn>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
  name: 'clientplugingupdate',
  props: ['update'],
  data() {
    return {
      sites: [],
      changeLogHTML: '',
      serverURL: window.serverURL
    };
  },
  computed: {
    appInfo() {
      return this.$store.getters.getAppInfo;
    }
  },
  methods: {
    getSelectedSites() {
      this.changeLogHTML = this.update.clientUpdateChangeLog;
      this.sites = this.update.siteIDs;
      this.allSites = this.$store.getters.getSites;
    },
    close() {
      this.$refs.clientpluginupdate.hide();
    },
    updateAll() {
      let payload = {};
      payload['action'] = 'updateClient';
      payload['args'] = {};
      payload['args']['siteIDs'] = this.update.siteIDs;
      payload['args']['params'] = {};
      payload['args']['params'][
        'clientUpdateVersion'
      ] = this.update.clientUpdateVersion;
      payload['args']['params'][
        'clientUpdatePackage_b64encoded'
      ] = this.update.clientUpdatePackage;
      payload['requiredData'] = {};
      payload['requiredData']['getClientUpdateAvailableSiteIDs'] = 1;
      this.$store.dispatch('sendAction', payload).then(response => {
        console.log('client plugin update action sent');
        this.close();
        // this.$store.commit(
        //   "SET_CLIENT_PLUGIN_UPDATES",
        //   response.data.getClientUpdateAvailableSiteIDs
        // );
      });
    }
  }
};
</script>

<style scoped>
.update-site-list{
    max-height: 500px;
    overflow: auto;
}
</style>
